'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sectionItem = require('./section-item');

var _sectionItem2 = _interopRequireDefault(_sectionItem);

var _adjustScrollingMixin = require('./adjust-scrolling-mixin');

var _adjustScrollingMixin2 = _interopRequireDefault(_adjustScrollingMixin);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ApiMenuSection = _react2['default'].createClass({
    displayName: 'ApiMenuSection',


    mixins: [_adjustScrollingMixin2['default']],

    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        url: _react2['default'].PropTypes.string,
        reference: _react2['default'].PropTypes.string.isRequired,
        items: _react2['default'].PropTypes.array,
        initiallyActiveItem: _react2['default'].PropTypes.string,
        initiallyActiveSubItem: _react2['default'].PropTypes.string,
        isInitiallyActive: _react2['default'].PropTypes.bool,
        isInitiallyCollapsed: _react2['default'].PropTypes.bool.isRequired,
        menuIsFixed: _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            isActive: this.props.isInitiallyActive,
            isCollapsed: this.props.isInitiallyCollapsed,
            activeItem: this.props.initiallyActiveItem,
            activeSubItem: this.props.initiallyActiveSubItem
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState({
            'isActive': newProps.isInitiallyActive,
            'isCollapsed': newProps.isInitiallyCollapsed,
            'activeItem': newProps.initiallyActiveItem,
            'activeSubItem': newProps.initiallyActiveSubItem
        });
    },
    componentDidUpdate: function componentDidUpdate() {
        this.adjustScrolling();
    },
    toggleSection: function toggleSection() {
        this.setState({
            'isCollapsed': !this.state.isCollapsed
        });
    },
    render: function render() {

        var title = this.props.title;

        var classes = (0, _classnames2['default'])({
            'l-api-docs-menu--section': true,
            'small-6': true,
            'medium-12': true,
            'large-12': true,
            'is-active': this.state.isActive,
            'is-expandable': this.props.items && this.props.items.length > 0,
            'is-collapsed': this.state.isCollapsed
        });

        var items = this.props.items ? this.props.items.map(function (item) {

            var isActive = this.state.activeItem != null && this.state.activeItem.toLowerCase() == item.reference.toLowerCase();

            return _react2['default'].createElement(_sectionItem2['default'], {
                key: 'item_' + item.reference,
                title: item.title,
                reference: item.reference,
                url: item.url,
                subItems: item.subItems,
                initiallyActiveSubItem: this.state.activeSubItem,
                isInitiallyActive: isActive });
        }.bind(this)) : null;

        return _react2['default'].createElement(
            'div',
            { className: classes, 'data-ref': this.props.reference },
            _react2['default'].createElement(
                'div',
                { className: 'l-api-docs-menu--section--title', onClick: items ? this.toggleSection : null },
                title
            ),
            items && items.length ? _react2['default'].createElement(
                'div',
                { className: 'l-api-docs-menu--items' },
                items
            ) : null
        );
    }
});

module.exports = ApiMenuSection;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/section.jsx
 ** module id = 864
 ** module chunks = 0
 **/